export default __webpack_public_path__ + "static/edge_logo-ae87971bfc3542375e31bd9d8449333e.svg";